import React, { useContext } from "react";
import { graphql, Link, useStaticQuery } from "gatsby";
import { AppContext } from "~context/AppContext";
import { DocumentContext } from "~context/DocumentContext";

const Notification = () => {
  const { notificationActive, setNotificationActive } = useContext(AppContext);
  const { device } = useContext(DocumentContext);

  //

  const { sanityNotification } = useStaticQuery(graphql`
    query Notification {
      sanityNotification {
        text
        clickTarget
      }
    }
  `);

  //

  if (!sanityNotification?.text) {
    return <></>;
  }

  const innerJSX = (
    <span className={`${device === `desktop` ? `b2` : `caption`}`}>
      {sanityNotification.text}
    </span>
  );

  const className = `notification ${
    notificationActive ? `active` : ``
  } w-full fixed top-0 right-0 bottom-0 left-0 z-40 flex items-center justify-center bg-orange text-bone text-center`;

  //

  if (sanityNotification?.clickTarget?.startsWith(`/`)) {
    return (
      <Link
        to={sanityNotification.clickTarget}
        className={className}
        onClick={() => setNotificationActive(false)}
      >
        {innerJSX}
      </Link>
    );
  }

  return (
    <button
      type="button"
      className={className}
      onClick={() => setNotificationActive(false)}
    >
      {innerJSX}
    </button>
  );
};

export default Notification;
